import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
// import PrivateRouter from '@/components/PrivateRouter';
import TokenWrapper from '@/container/Token';
// import privateRoutes from './Private';
import publicRoutes from './Public';
import NotFound from './NotFound';
import Loading from './components/Loading';

const BasicRouter = () => (
  <BrowserRouter>
    <Suspense fallback={<Loading />}>
      <Switch>
        {/* {privateRoutes.map(props =>
          <PrivateRouter
            {...props}
            key={`private-${props.path}`}
          />
        )} */}
        {publicRoutes.map(props => <Route {...props} key={`public-${props.path}`} />)}
        <Route component={() => <NotFound />} />
      </Switch>
    </Suspense>
  </BrowserRouter>
);

BasicRouter.propTypes = {
  path: PropTypes.string,
};

export default TokenWrapper(BasicRouter);
